import CacheUpdateNotice from "./CacheUpdateNotice";

const CacheUpdateModalBook = ({visible = false, ...props}) => {
    if (!visible) return null;
    return <CacheUpdateNotice mode="book_modal" {...props} />;
};

export default CacheUpdateModalBook;
